<div class="contest-card__wrapper">
    <div class="contest-card__content">
        <div class="contest-card__primary-content">
            <h2 *ngIf="contest.name"
                class="contest-card__title">{{ contest.name }}</h2>
            <p *ngIf="contest.description"
               class="contest-card__subtitle" [innerHTML]="contest.description"></p>
            <div class="contest-card__informations">
                <div *ngIf="contest.goals"
                     class="contest-card__goals">
                    <h3>{{ "contest.goals_title" | translate }}</h3>
                    <p [innerHTML]="contest.goals"></p>
                </div>
                <div class="contest-card__rules" *ngIf="contest.rulesAlias">
                    <a [routerLink]="['/page', contest.rulesAlias]">{{ "contest.see_rules" | translate }}</a>
                </div>
            </div>
        </div>
        <div class="contest-card__secondary-content">
            <app-contest-timer [targetDate]="contest.startDate"></app-contest-timer>
            <div class="contest-card__rewards" [innerHTML]="contest.prizes"></div>
        </div>
    </div>
    <div class="contest-card__footer">
        <div *ngIf="contest.startDate && contest.endDate"
             class="contest-card__dates">
            <div class="contest-card__start-date">
                <mat-icon svgIcon="event-upcoming"></mat-icon>
                <div>{{ "contest.from" | translate }} {{ contest.startDate | date: 'longDate' }}</div>
            </div>
            <div class="contest-card__end-date">
                <mat-icon svgIcon="event-available"></mat-icon>
                <div>{{ "contest.to" | translate }} {{ contest.endDate | date: 'longDate' }}</div>
            </div>
        </div>
        <div class="contest-card__inscription">
            <ng-container *ngIf="!isRegistered; else alreadyRegisteredBlock">
                <button *ngIf="canRegister && userHasRoleForContest()"
                        (click)="registerToContest()"
                        [disabled]="isRegistering"
                >
                    <div>{{ "contest.register_self" | translate }}</div>
                    <mat-icon svgIcon="register" *ngIf="!isRegistering; else spinnerBlock"></mat-icon>
                </button>
            </ng-container>
            <ng-template #alreadyRegisteredBlock>
                <div class="contest-card__shareable-code"
                     *ngIf="canShareCode"
                     (click)="copyShareableCode()"
                     (mouseenter)="onEnterShareableCode()"
                     (mouseleave)="onLeaveShareableCode()"
                >
                    {{ 'contest.my_sponsor_code' | translate }}
                    <span>{{ shareableCode }}</span>
                    <div class="contest-card__shareable-code-tooltip"
                         matTooltip="{{ shareableCodeTooltip | translate}}"
                         #shareableCodeBlock="matTooltip"></div>
                </div>
                <ng-container *ngIf="!isOpen">
                    <div class="contest-card__shareable-code">
                        {{ 'contest.registered' | translate }}
                    </div>
                    <button *ngIf="canRegisterGroups"
                            (click)="editRegistration()"
                            [disabled]="isRegistering"
                    >
                        <div>{{ "contest.edit_register_self" | translate }}</div>
                        <mat-icon svgIcon="register" *ngIf="!isRegistering; else spinnerBlock"></mat-icon>
                    </button>
                </ng-container>
                <a *ngIf="isOpen"
                   [routerLink]="['/contests', contest.id, 'home']">
                    <div>{{ "contest.open" | translate }}</div>
                    <mat-icon svgIcon="register"></mat-icon>
                </a>
            </ng-template>
        </div>
    </div>
</div>

<ng-template #spinnerBlock>
    <mat-spinner diameter="24"></mat-spinner>
</ng-template>